/** Limite caratteri prompt (UI partecipante, API `/api/participant/prompt`, maxischermo). */
export const PROMPT_CHAR_LIMIT = 2000;
